import * as R from 'ramda'

/**
 * This removes keys having null, empty string value from an object
 * @type {*|(function(*=): (*))}
 */
const rejectNullEmptyKeys = R.pickBy(x => !R.isNil(x) && x !== '')

export default rejectNullEmptyKeys
